import { toast } from "react-toastify";

class SnackbarHandler {
  authErrorToast = (text: string) => {
    toast(text, { position: "bottom-center", type: "error", toastId:"authErrorToast" });
  };
  likeErrorToast = (text: string) => {
    toast(text, { position: "bottom-center", type: "error", toastId: "likeErrorToast"
  });
  };
  emptyCommentWarningToast = (text: string) => {
    toast(text, { position: "bottom-center", type: "warning", toastId: "emptyCommentErrorToast"
  });
  };
  contactErrorToast = (text: string) => {
    toast(text, { position: "bottom-center", type: "error", toastId: "contactErrorToast"
  });
  };
  successToast = (text: string) => {
    toast(text, { position: "bottom-center", type: "success" });
  };

  normalToast = (text: string) => {
    toast(text, { position: "bottom-center", type: "dark" });
  };
}

export default new SnackbarHandler();
